import React from 'react'
import { IBookingProvider } from './BookingPageTypes'

export const BookingPageContext = React.createContext(
    {} as IBookingProvider
)
export const BookingPageProvider = BookingPageContext.Provider
